<template>
    <nav class="top-menu">
        <li v-for="item in menuList" :key="item.id" :class="{ 'active': currentId == item.id }"
            @click="changeUrl(item)">
            {{ item.name }}</li>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            menuList: [
                {
                    name: "流量管理",
                    id: 2,
                    url: "/mymedia/list"
                },
                {
                    name: "数据报表",
                    id: 4,
                    url: "/myindex",
                },
                {
                    name: "对接中心",
                    id: 8,
                    url: "/doc"
                }
            ],
        };
    },
    computed: {
        currentId() {
            let path = this.$route.path;
            if (path.indexOf('mymedia') > -1) {
                return 2
            } else if (path.indexOf('myindex') > -1) {
                return 4
            }
            return 8
        }
    },
    methods: {
        changeUrl(item) {
            this.$router.push({ path: item.url })
        }
    },
}
</script>
<style lang="scss" scoped>
.top-menu {
    display: flex;
    height: 60px;
    margin-left: 80px;

    li {
        height: 60px;
        line-height: 60px;
        padding: 0;
        margin: 0 18px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;

        &.active {
            color: var(--color-main);
            background: none!important;
            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 30px;
                height: 2px;
                background-color: var(--color-main);
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/Menu.vue